import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="footer footer-big footer-color-black">
    <Container>
      <Row>
        <Col md="12" lg="4" className="mb-3">
          <div className="info">
            <h5 className="title">Sobre Kia's</h5>
            <nav>
              <ul>
                <li>
                  <Link className="text-white" to="/">
                    Home
                  </Link>
                </li>
                {/* <li>
                 <Link to="/clientes">Nuestros Clientes</Link>
               </li>
               <li>
                 <Link to="/nosotros">Sobre Nosotros</Link>
               </li> */}
              </ul>
            </nav>
          </div>
        </Col>
        <Col md="12" lg="4" className="mb-3">
          <div className="info">
            <h5 className="title">Realiza una cotización</h5>
            <nav>
              <ul>
                <li>
                  <Link className="text-white" to="/contacto">
                    Contáctanos
                  </Link>
                </li>
                <li>
                  <Link className="text-white" to="/contacto">
                    Pautar Cita
                  </Link>
                </li>
                {/* <li>
                 <Link to="/tos">Terminos &amp; Condiciones</Link>
               </li>
               <li>
                 <Link to="/politicas">Políticas de la compañía</Link>
               </li> */}
              </ul>
            </nav>
          </div>
        </Col>
        <Col md="12" lg="4" className="mb-3">
          <div className="info">
            <h5 className="title">Siguenos en:</h5>
            <nav>
              <ul>
                <li>
                  <a
                    href="https://www.facebook.com/Kias-Proyectos-110634694873733/"
                    className="btn btn-social btn-facebook btn-simple"
                  >
                    <i className="fa fa-facebook-square" /> Facebook
                  </a>
                </li>
                <li>
                  <a
                    href="https://instagram.com/kiasmuebles"
                    className="btn btn-social btn-reddit btn-simple"
                  >
                    <i className="fa fa-instagram" /> Instagram
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </Col>
      </Row>
      <hr />
      <div className="copyright">
        © {new Date().getFullYear()} Kia's, Desarrollado por{' '}
        <a
          href="https://avilatek.dev"
          target="_blank"
          rel="noopener noreferrer"
        >
          Avila Tek.
        </a>
      </div>
    </Container>
  </footer>
);

export default Footer;
